export const currencies = [
  {
    label: "sats",
    value: "sat",
    decimals: 0
  },
  {
    label: "BTC",
    value: "BTC",
    decimals: 8
  },
  {
    label: "EUR • Euro 🇪🇺",
    value: "EUR" as const
  },
  {
    label: "CHF • Swiss franc 🇨🇭",
    value: "CHF" as const
  },
  {
    label: "GBP • Pound sterling 🇬🇧",
    value: "GBP" as const
  },
  {
    label: "USD • United States dollar 🇺🇸",
    value: "USD" as const
  },
  {
    label: "JPY • Japanese yen 🇯🇵",
    value: "JPY" as const,
    decimals: 0
  },
  {
    label: "HKD • Hong Kong dollar 🇭🇰",
    value: "HKD" as const
  },
  {
    label: "SGD • Singapore dollar 🇸🇬",
    value: "SGD" as const
  },
  {
    label: "NOK • Norwegian krone 🇳🇴",
    value: "NOK" as const
  },
  {
    label: "NZD • New Zealand dollar 🇳🇿",
    value: "NZD" as const
  },
  {
    label: "SEK • Swediss krona 🇸🇪",
    value: "SEK" as const
  },
  {
    label: "DKK • Danish krone 🇩🇰",
    value: "DKK" as const
  },
  {
    label: "AUD • Australian dollar 🇦🇺",
    value: "AUD" as const
  },
  {
    label: "CAD • Canadian dollar 🇨🇦",
    value: "CAD" as const
  },
  {
    label: "PLN • Polish złoty 🇵🇱",
    value: "PLN" as const
  },
  {
    label: "CZK • Czech koruna 🇨🇿",
    value: "CZK" as const
  },
  {
    label: "AED • United Arab Emirates dirham 🇦🇪",
    value: "AED" as const
  },
  {
    label: "HUF • Hungarian forint 🇭🇺",
    value: "HUF" as const
  },
  {
    label: "MXN • Mexican peso 🇲🇽",
    value: "MXN" as const
  },
  {
    label: "ZAR • South African rand 🇿🇦",
    value: "ZAR" as const
  },
  {
    label: "AFN • Afgan afghani",
    value: "AFN" as const
  },
  {
    label: "ALL • Albanian lek",
    value: "ALL" as const
  },
  {
    label: "AMD • Armenian dram",
    value: "AMD" as const
  },
  {
    label: "ANG • Netherlands Antillean guilder",
    value: "ANG" as const
  },
  {
    label: "AOA • Angolan kwanza",
    value: "AOA" as const
  },
  {
    label: "ARS • Argentine peso",
    value: "ARS" as const
  },
  {
    label: "AWG • Aruban floring",
    value: "AWG" as const
  },
  {
    label: "AZN • Azerbaijani manat",
    value: "AZN" as const
  },
  {
    label: "BAM • Bosnia and Herzegovina convertible mark",
    value: "BAM" as const
  },
  {
    label: "BBD • Barbados dollar",
    value: "BBD" as const
  },
  {
    label: "BDT • Bangladeshi taka",
    value: "BDT" as const
  },
  {
    label: "BGN • Bulgarian Iev",
    value: "BGN" as const
  },
  {
    label: "BHD • Bahraini dinar",
    value: "BHD" as const
  },
  {
    label: "BIF • Burundian franc",
    value: "BIF" as const,
    decimals: 0
  },
  {
    label: "BMD • Bermudian dollar",
    value: "BMD" as const
  },
  {
    label: "BND • Brunei dollar",
    value: "BND" as const
  },
  {
    label: "BOB • Boliviano",
    value: "BOB" as const
  },
  {
    label: "BRL • Brazilian real",
    value: "BRL" as const
  },
  {
    label: "BSD • Bahamian dollar",
    value: "BSD" as const
  },
  {
    label: "BTN • Bhutanese ngultrum",
    value: "BTN" as const
  },
  {
    label: "BWP • Botswana pula",
    value: "BWP" as const
  },
  {
    label: "BYN • Belarusian ruble",
    value: "BYN" as const
  },
  {
    label: "BZD • Belize dollar",
    value: "BZD" as const
  },
  {
    label: "CDF • Congolese franc",
    value: "CDF" as const
  },
  {
    label: "CLF • Unidad de Fomento",
    value: "CLF" as const,
    decimals: 4
  },
  {
    label: "CLP • Chilean peso",
    value: "CLP" as const
  },
  {
    label: "CNH",
    value: "CNH" as const
  },
  {
    label: "CNY • Renminbi yuan",
    value: "CNY" as const
  },
  {
    label: "COP • Colombian peso",
    value: "COP" as const
  },
  {
    label: "CRC • Costa Rican colon",
    value: "CRC" as const
  },
  {
    label: "CUC • Cuban convertible peso",
    value: "CUC" as const
  },
  {
    label: "CUP • Cuban peso",
    value: "CUP" as const
  },
  {
    label: "CVE • Cape Verdean escudo",
    value: "CVE" as const
  },
  {
    label: "DJF • Djiboutian franc",
    value: "DJF" as const,
    decimals: 0
  },
  {
    label: "DOP • Dominican peso",
    value: "DOP" as const
  },
  {
    label: "DZD • Algerian dinar",
    value: "DZD" as const
  },
  {
    label: "EGP • Egyptian pound",
    value: "EGP" as const
  },
  {
    label: "ERN • Eritran nakfa",
    value: "ERN" as const
  },
  {
    label: "ETB • Ethiopian birr",
    value: "ETB" as const
  },
  {
    label: "FJD • Fiji dollar",
    value: "FJD" as const
  },
  {
    label: "FKP • Falklan Island pound",
    value: "FKP" as const
  },
  {
    label: "GEL • Georgian Iari",
    value: "GEL" as const
  },
  {
    label: "GGP",
    value: "GGP" as const
  },
  {
    label: "GHS • Ghanaian cedi",
    value: "GHS" as const
  },
  {
    label: "GIP • Gibraltar pound",
    value: "GIP" as const
  },
  {
    label: "GMD • Gambian dalasi",
    value: "GMD" as const
  },
  {
    label: "GNF • Guinean franc",
    value: "GNF" as const,
    decimals: 0
  },
  {
    label: "GTQ • Guatemalan quetzal",
    value: "GTQ" as const
  },
  {
    label: "GYD • Guyanese dollar",
    value: "GYD" as const
  },
  {
    label: "HNL • Honduran lempira",
    value: "HNL" as const
  },
  {
    label: "HRK • Croatian kuna",
    value: "HRK" as const
  },
  {
    label: "HTG • Haitian gourde",
    value: "HTG" as const
  },
  {
    label: "IDR • Indonesian rupiah",
    value: "IDR" as const
  },
  {
    label: "ILS • Israeli new shekel",
    value: "ILS" as const
  },
  {
    label: "IMP",
    value: "IMP" as const
  },
  {
    label: "INR • Indian rupee",
    value: "INR" as const
  },
  {
    label: "IQD • Iraqi dinar",
    value: "IQD" as const
  },
  {
    label: "IRR",
    value: "IRR" as const
  },
  {
    label: "ISK • Icelandic króna",
    value: "ISK" as const
  },
  {
    label: "JEP",
    value: "JEP" as const
  },
  {
    label: "JMD • Jamaican dollar",
    value: "JMD" as const
  },
  {
    label: "JOD • Jordanian dinar",
    value: "JOD" as const
  },
  {
    label: "KES • Kenyan shilling",
    value: "KES" as const
  },
  {
    label: "KGS • Kyrgyzstani som",
    value: "KGS" as const
  },
  {
    label: "KHR • Cambodian riel",
    value: "KHR" as const
  },
  {
    label: "KMF • Comoro franc",
    value: "KMF" as const,
    decimals: 0
  },
  {
    label: "KPW • North Korean won",
    value: "KPW" as const
  },
  {
    label: "KRW • South Korean won",
    value: "KRW" as const,
    decimals: 0
  },
  {
    label: "KWD • Kuwaiti dinar",
    value: "KWD" as const
  },
  {
    label: "KYD • Cayman Islands dollar",
    value: "KYD" as const
  },
  {
    label: "KZT • Kazakhstani tenge",
    value: "KZT" as const
  },
  {
    label: "LAK • Lao kip",
    value: "LAK" as const
  },
  {
    label: "LBP • Lebanese pound",
    value: "LBP" as const
  },
  {
    label: "LKR • Sri Lankan rupee",
    value: "LKR" as const
  },
  {
    label: "LRD • Liberian dollar",
    value: "LRD" as const
  },
  {
    label: "LSL • Lesotho loti",
    value: "LSL" as const
  },
  {
    label: "LYD • Libyan dinar",
    value: "LYD" as const
  },
  {
    label: "MAD • Moroccan dirham",
    value: "MAD" as const
  },
  {
    label: "MDL • Moldovan leu",
    value: "MDL" as const
  },
  {
    label: "MGA • Malagasy ariary",
    value: "MGA" as const
  },
  {
    label: "MKD • Macedonian denar",
    value: "MKD" as const
  },
  {
    label: "MMK • Myanmar kyat",
    value: "MMK" as const
  },
  {
    label: "MNT • Mongolian tögrög",
    value: "MNT" as const
  },
  {
    label: "MOP • Macanese pataca",
    value: "MOP" as const
  },
  {
    label: "MRO",
    value: "MRO" as const,
    decimals: 1
  },
  {
    label: "MUR • Mauritian rupee",
    value: "MUR" as const
  },
  {
    label: "MVR • Maldivian rufiyaa",
    value: "MVR" as const
  },
  {
    label: "MWK • Malawian kwache",
    value: "MWK" as const
  },
  {
    label: "MYR • Malaysian ringgit",
    value: "MYR" as const
  },
  {
    label: "MZN • Mozamican metical",
    value: "MZN" as const
  },
  {
    label: "NAD • Namiian dollar",
    value: "NAD" as const
  },
  {
    label: "NGN • Nigerian naira",
    value: "NGN" as const
  },
  {
    label: "NIO • Nicaraguan córdoba",
    value: "NIO" as const
  },
  {
    label: "NPR • Nepalese rupee",
    value: "NPR" as const
  },
  {
    label: "OMR • Omani rial",
    value: "OMR" as const
  },
  {
    label: "PAB • Panamanian balboa",
    value: "PAB" as const
  },
  {
    label: "PEN • Peruvian sol",
    value: "PEN" as const
  },
  {
    label: "PGK • Papua New Guinean kina",
    value: "PGK" as const
  },
  {
    label: "PHP • Philippine peso",
    value: "PHP" as const
  },
  {
    label: "PKR • Pakistan rupee",
    value: "PKR" as const
  },
  {
    label: "PYG • Paraguayan guaraní",
    value: "PYG" as const,
    decimals: 0
  },
  {
    label: "QAR • Qatari riyal",
    value: "QAR" as const
  },
  {
    label: "RON • Romanian leu",
    value: "RON" as const
  },
  {
    label: "RSD • Serbian dinar",
    value: "RSD" as const
  },
  {
    label: "RUB • Russian ruble",
    value: "RUB" as const
  },
  {
    label: "RWF • Rwandan franc",
    value: "RWF" as const,
    decimals: 0
  },
  {
    label: "SAR • Saudi riyal",
    value: "SAR" as const
  },
  {
    label: "SBD • Solomon Islands dollar",
    value: "SBD" as const
  },
  {
    label: "SCR • Seychelles rupee",
    value: "SCR" as const
  },
  {
    label: "SDG • Sudanese pound",
    value: "SDG" as const
  },
  {
    label: "SHP • Saint Helena leone",
    value: "SHP" as const
  },
  {
    label: "SLL • Sierra Leonean leone",
    value: "SLL" as const
  },
  {
    label: "SOS • Somali shilling",
    value: "SOS" as const
  },
  {
    label: "SRD • Surinamese dollar",
    value: "SRD" as const
  },
  {
    label: "SSP • South Sudanese pound",
    value: "SSP" as const
  },
  {
    label: "STD",
    value: "STD" as const
  },
  {
    label: "SVC • Salvadoran colón",
    value: "SVC" as const
  },
  {
    label: "SYP • Syrian pound",
    value: "SYP" as const
  },
  {
    label: "SZL • Swazi lilangeni",
    value: "SZL" as const
  },
  {
    label: "THB • Thai baht",
    value: "THB" as const
  },
  {
    label: "TJS • Tajikistani somoni",
    value: "TJS" as const
  },
  {
    label: "TMT • Turkmenistan manat",
    value: "TMT" as const
  },
  {
    label: "TND • Tunisian dinar",
    value: "TND" as const
  },
  {
    label: "TOP • Tongan pa'anga",
    value: "TOP" as const
  },
  {
    label: "TRY • Turkish lira",
    value: "TRY" as const
  },
  {
    label: "TTD • Trinid and Tobago dollar",
    value: "TTD" as const
  },
  {
    label: "TWD • New Taiwan dollar",
    value: "TWD" as const
  },
  {
    label: "TZS • Tanzanian shilling",
    value: "TZS" as const
  },
  {
    label: "UAH • Ukrainian hryvnia",
    value: "UAH" as const
  },
  {
    label: "UGX • Ugandan shilling",
    value: "UGX" as const,
    decimals: 0
  },
  {
    label: "UYU • Uruguyan peso",
    value: "UYU" as const
  },
  {
    label: "UZS • Uzbekistan som",
    value: "UZS" as const
  },
  {
    label: "VES • Venezuelan bolívar soberano",
    value: "VES" as const
  },
  {
    label: "VND • Vietnamese đồng",
    value: "VND" as const,
    decimals: 0
  },
  {
    label: "VUV • Vanuatu vatu",
    value: "VUV" as const,
    decimals: 0
  },
  {
    label: "WST • Samoan tala",
    value: "WST" as const
  },
  {
    label: "XAF",
    value: "XAF" as const,
    decimals: 0
  },
  {
    label: "XAG • Silver",
    value: "XAG" as const
  },
  {
    label: "XAU • Gold",
    value: "XAU" as const
  },
  {
    label: "XCD • East Caribbean dollar",
    value: "XCD" as const
  },
  {
    label: "XDR",
    value: "XDR" as const
  },
  {
    label: "XOF • CFA franc BCEAO",
    value: "XOF" as const,
    decimals: 0
  },
  {
    label: "XPD",
    value: "XPD" as const
  },
  {
    label: "XPF • Franc pacifique",
    value: "XPF" as const,
    decimals: 0
  },
  {
    label: "XPT",
    value: "XPT" as const
  },
  {
    label: "YER • Yemen rial",
    value: "YER" as const
  },
  {
    label: "ZMW • Zambian kwacha",
    value: "ZMW" as const
  },
  {
    label: "ZWL • Zimabwean dollar",
    value: "ZWL" as const
  }
];
